import { render, staticRenderFns } from "./medical.vue?vue&type=template&id=2997234f&scoped=true"
import script from "./medical.vue?vue&type=script&lang=ts"
export * from "./medical.vue?vue&type=script&lang=ts"
import style0 from "./medical.vue?vue&type=style&index=0&id=2997234f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2997234f",
  null
  
)

export default component.exports